module.exports = __webpack_public_path__ + "img/gift2.b6a6f67c.png";